import { openBlock as r, createElementBlock as o, createElementVNode as l } from "vue";
import { _ as t } from "./main-1yGBZlc-.js";
const n = {}, d = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
function i(p, e) {
  return r(), o("svg", d, e[0] || (e[0] = [
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M19.0365 4.9051C22.9389 8.80752 22.9389 15.1345 19.0367 19.0367C15.1344 22.9389 8.80747 22.9389 4.90524 19.0367C1.00301 15.134 1.00301 8.80726 4.90524 4.9051C8.80747 1.00291 15.1343 1.00291 19.0365 4.9051Z",
      fill: "var(--purple-20)",
      stroke: "var(--purple)"
    }, null, -1),
    l("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M10.577 14.9022L14.9297 10.5781L14.9295 14.9022H10.577ZM13.3908 9.04956L9.03844 13.3736L9.03809 9.04956H13.3908Z",
      fill: "var(--purple)"
    }, null, -1)
  ]));
}
const f = /* @__PURE__ */ t(n, [["render", i]]);
export {
  f as default
};
